export const DATEPICKER_KEYBOARD_HINT: string =
  'Press Alt plus Down Arrow to open the calendar. Once open, use the arrow keys to move between dates and press Enter to select a date.';

export const MULTISELECT_KEYBOARD_HINT: string =
  'Start typing to search for a language and press Enter to add it. To remove a selected language, use the arrow keys to move to it, then press Delete or Backspace.';

export const TIMEPICKER_KEYBOARD_HINT: string =
  'Press Alt plus Down Arrow to open the time picker. Once open, use the arrow keys to move between times and press Enter to select a time.';